export class Mood {
    constructor() {
    }

    moodId: string;
    name: string;
    picture: string;
}
